module.exports = __webpack_public_path__ + "static/img/article_03.6eddc68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2024/galaxy_award/article_03.png
// module id = DR96
// module chunks = 0